module.exports = __webpack_public_path__ + "static/header-sme-af3485a24eeecba599cf8cd94d1dcad6.png";